import React, { useEffect, useState } from "react";
import Filter from "../../../../assets/Icons/filter.png";
import ExcelExport from "../../../../compnenets/commons/xls";
import Modal from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../archival.css";
import { PROJECT_ARCHIVAL } from "../../../../services/apiCalls/archivalApiCalls";

export default function DprRecord({ project }) {
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const [issueData, setIssueData] = useState([]);
  const [filterData, setFilterData] = useState({
    ProjectID: project.project_id,
    StartDate: "",
    EndDate: "",
    Activity_Task: "",
    Issue_Status: "",
    sortOrder: "ASC",
    sortBy: "Site Vist/Audit Date",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(issueData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = issueData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const fetchArchivalIssue = async (payload) => {
    let obj = payload;
    if (!payload) {
      obj = {
        ProjectID: project.project_id,
      };
    }
    const response = await PROJECT_ARCHIVAL.GetIssues(obj);
    if (response && response.RiskList.length > 0) {
      setIssueData(response.RiskList);
    } else {
      setIssueData([]);
    }
  };
  useEffect(() => {
    fetchArchivalIssue();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <React.Fragment>
      <Modal open={open} onClose={() => {}} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Issue Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    name="StartDate"
                    className="form-control shadow-none"
                    value={filterData.StartDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="EndDate"
                    value={filterData.EndDate}
                    className="form-control shadow-none"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Activity/Task</label>
                  <input
                    type="text"
                    name="Activity_Task"
                    value={filterData.Activity_Task}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">Issue Status</label>
                  <select
                    className="filter-label"
                    name="Issue_Status"
                    value={filterData.Issue_Status}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                    <option value="Open">Open</option>
                    <option value="Resolved">Resolved</option>
                  </select>
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Work Package</label>
                  <select
                    className="filter-label"
                    name="workpackage"
                    value={filterData.workpackage}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Issue</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option>ASC</option>
                <option>DES</option>
              </select>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginLeft: 20 }}>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Role"
              value="option1"
            />
            <label for="Role" style={{ fontSize: 14 }}>
              Impact level
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Type"
              value="option1"
            />
            <label for="Type" style={{ fontSize: 14 }}>
              Priority Level
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input shadow-none"
              type="radio"
              name="exampleRadios"
              id="Created"
              value="option1"
            />
            <label for="Created" style={{ fontSize: 14 }}>
              Created date
            </label>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              fetchArchivalIssue(filterData);
              setOpen(false);
              setCurrentPage(1);
            }}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={issueData}
              fileName="Issues"
              sheet="Issues List"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto" onClick={() => fetchArchivalIssue()}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-archival">
        <table id="custom-table-archival">
          <thead className="table-header-archival">
            <tr>
              <th>Sr No</th>
              <th>Project Name</th>
              <th>Project Categroy</th>
              <th>Activity/Task</th>
              <th>Work Package</th>
              <th>Impact Description</th>
              <th>Issue Description</th>
              <th>Priority Level</th>
              <th style={{ whiteSpace: "nowrap" }}>Impact Level</th>
              <th>Issue Status</th>
              <th>Migration Strategy</th>
              <th>Assigned Person</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>
                  <td>{index + 1 + (currentPage - 1) * 10}</td>
                </td>
                <td>{row.ProjectName}</td>
                <td>{row.ProductCategory}</td>
                <td>{row.ActivityTask}</td>
                <td>workpackage name</td>
                <td>{row.ImpactDescription}</td>
                <td>{row.IssueDescription}</td>
                <td style={{ whiteSpace: "nowrap" }}>{row.PriorityLevel}</td>
                <td>{row.ImpactLevel}</td>
                <td>{row.IssueStatus}</td>
                <td>{row.MitigationStrategy}</td>
                <td>{row.AssignedPersonEmail}</td>
                <td>{new Date(row?.CreateOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min((currentPage - 1) * rowsPerPage + 1, issueData.length)} to{" "}
          {Math.min(currentPage * rowsPerPage, issueData.length)} of{" "}
          {issueData.length} entries
        </div>

        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>

          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
